import {AnalyticsConfig} from "./valio-environment.objects";

export const ANALYTICS_FEATURE = 'analyticsConfig';

export interface ValioEnvironmentState {
  analyticsConfig: AnalyticsConfig | undefined;
}
